import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { GoogleOAuthProvider } from '@react-oauth/google' // 新增：引入 GoogleOAuthProvider

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* 新增：將 GoogleOAuthProvider 包覆在 App 外層 */}
    {/* 💡 請將 clientId 替換成您在 Google Cloud Console 申請的真實憑證 */}
    <GoogleOAuthProvider clientId="665155831844-fo714ebp7qr3ifh2lo8c1llpm295pb80.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </StrictMode>,
)